import { PlatoLogo } from '@/assets/icons/plato-logo';
import { Button } from '@/components/ui/button';
import { IntercomLauncher } from '@/features/intercom/components/intercom-launcher';
import { cn } from '@/lib/utils';
import { MenuIcon, XIcon } from 'lucide-react';
import type { FC } from 'react';
import { Link } from 'react-router-dom';
import { Drawer } from 'vaul';
import { CreateNewMenu } from './create-new-menu';
import { GlobalSearchBar } from './global-search-bar';
import { NavigationList } from './navigation-list';

export interface MobileNavProps {
    mobileDrawerOpen: boolean;
    setMobileDrawerOpen: (open: boolean) => void;
    closeDrawer: () => void;
}

export const MobileNav: FC<MobileNavProps> = ({ mobileDrawerOpen, setMobileDrawerOpen, closeDrawer }) => {
    return (
        <Drawer.Root direction="top" open={mobileDrawerOpen} onOpenChange={setMobileDrawerOpen}>
            <div className="relative z-40 flex items-center gap-3 border-b border-neutral-200 bg-neutral-50 p-4 pl-3 sm:hidden">
                <Drawer.Trigger asChild>
                    <Button
                        size="icon-s"
                        variant="outline"
                        onClick={() => setMobileDrawerOpen(true)}
                        icon={mobileDrawerOpen ? XIcon : MenuIcon}
                    />
                </Drawer.Trigger>
                <Link to="/" className="flex shrink-0 items-center justify-center h-8 w-8">
                    <PlatoLogo className="h-7 w-auto" />
                </Link>
                <GlobalSearchBar showFullInput showShortcutKey={false} className="min-w-[120px] grow" />
                <IntercomLauncher expanded={false} variant="outline" />
                <CreateNewMenu onClose={closeDrawer} showFullInput={false} />
            </div>
            <Drawer.Portal>
                <Drawer.Overlay className="fixed inset-0 top-[65px] z-30 bg-black/20" />
                <Drawer.Content
                    className={cn(
                        'fixed inset-x-0 top-[65px] z-30 flex h-[calc(100dvh-65px)]',
                        'flex-col overflow-y-auto bg-neutral-50 shadow-lg',
                    )}
                >
                    <div className="flex h-full flex-col items-start gap-3 bg-neutral-50 p-3 pl-2">
                        <NavigationList closeDrawer={closeDrawer} />
                    </div>
                </Drawer.Content>
            </Drawer.Portal>
        </Drawer.Root>
    );
};
